import Main from './Main'
import Lista from './components/Feriado'
import Novo from './components/NovoFeriado'

export default [
  {
    path: 'feriado',
    name: 'config.feriado',
    component: Main,
    redirect: { name: 'config.feriado.list' },
    children: [
      {
        path: '/',
        name: 'config.feriado.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.feriado.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.feriado.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/feriado/routes.js